import '../knockout-extensions';
import $ from 'jquery';
import Bloodhound from 'typeahead.js/dist/bloodhound.min';
import ko from 'knockout';

const SCROLL_TO_EDIT = 'scrollToEdit';
const EDIT_SCROLL_POSITION = 'editScrollPosition';

window.onload = function () {
    const scrollTop = sessionStorage.getItem(EDIT_SCROLL_POSITION);
    if (sessionStorage.getItem(SCROLL_TO_EDIT) === 'true' && scrollTop) {
        $(document).scrollTop(+scrollTop);
        sessionStorage.removeItem(EDIT_SCROLL_POSITION);
    }
    sessionStorage.removeItem(SCROLL_TO_EDIT);
}

ko.bindingHandlers.typeahead = {
    update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        var element = $(element);

        element.typeahead('destroy');

        var allBindings = allBindingsAccessor();
        var value = allBindings.value;
        var source = ko.utils.unwrapObservable(valueAccessor());
        var items = ko.utils.unwrapObservable(allBindings.items) || 4;

        var dataset = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                url: source,
                wildcard: '%QUERY',
            },
        });

        element
            .typeahead(null, {
                displayKey: 'name',
                source: dataset.ttAdapter(),
                limit: 150,
            })
            .attr('autocomplete', 'off')
            .bind('typeahead:select', function (ev, suggestion) {
                if (value) value(suggestion.name);
            });
    },
};

var BaseName = function (data, parent, variant) {
    var self = this;
    self.namePrefix = ko.observableTS(data['namePrefix']);
    self.name = ko.observableTS(data['name']);
    self.variant = ko.observableTS(variant);

    self.dump = function () {
        return {
            name: self.name(),
            namePrefix: self.namePrefix(),
        };
    };

    self.getTimeStamp = function () {
        return Math.max(self.namePrefix.getTimeStamp(), self.name.getTimeStamp());
    };
};

var NameList = function (data, parent, name, variantName, limit, autocomplete) {
    var self = this;
    self.name = name;
    self.variantName = variantName;

    self.names = ko.observableArray(
        data.map(function (v, i) {
            return new BaseName(v, null, i != 0);
        })
    );
    if (self.names().length == 0) self.names([new BaseName({}, null, false)]);

    self.canAdd = ko.computed(function () {
        return self.names().length < limit;
    });

    self.add = function () {
        self.names.push(new BaseName({}, null, true));
    };

    self.placeholder = function (data) {
        return data.variant() ? self.variantName : self.name;
    };

    self.autocomplete = ko.computed(function () {
        return ko.observable(
            '/cabinet/ajax/autocomplete/' + autocomplete + '/?query=%QUERY&sex=' + parent.sex()
        );
    });

    self.dump = function () {
        return self.names().map(function (n) {
            return n.dump();
        });
    };

    self.getNameList = function () {
        return self
            .names()
            .map(function (v) {
                return { name: v.name(), prefix: v.namePrefix() };
            })
            .filter(function (v) {
                return v['name'];
            });
    };

    self.getTimeStamp = function () {
        return self.names().reduce(function (result, n) {
            return Math.max(result, n.getTimeStamp());
        }, 0);
    };
};

var NamesForm = function (data) {
    var self = this;
    self.sex = ko.observable(data['sex']);
    self.surnames = new NameList(
        data['surnames'],
        self,
        'Фамилия',
        'Вариант фамилии',
        3,
        'surname'
    );
    self.names = new NameList(data['names'], self, 'Имя', 'Вариант имени', 3, 'name');
    self.secondNames = new NameList(
        data['secondNames'],
        self,
        'Отчество',
        'Вариант отчества',
        3,
        'second_name'
    );

    self.lists = ko.observableArray([self.surnames, self.names, self.secondNames]);
    self.namesData = ko.observable();

    self.onSave = function () {
        var d = JSON.stringify({
            surnames: self.surnames.dump(),
            names: self.names.dump(),
            secondNames: self.secondNames.dump(),
        });
        self.namesData(d);
    };

    self.getTimeStamp = function () {
        return Math.max(
            self.surnames.getTimeStamp(),
            self.names.getTimeStamp(),
            self.secondNames.getTimeStamp()
        );
    };
};

window.NamesForm = NamesForm;

var RankForm = function (data) {
    var self = this,
        selRankData = null,
        defaultRankData = { id: null, name: '--------', isMonk: false };

    self.rankPrefix = ko.observableTS(data['rankPrefix']);
    self.ranks = [defaultRankData].concat(data['ranks']);
    self.isPrimary = data['isPrimary'];

    for (var i = 0; i < self.ranks.length; i++) {
        if (data['rank'] == self.ranks[i]['id']) {
            selRankData = self.ranks[i];
            break;
        }
    }

    self.rank = ko.observableTS(selRankData || defaultRankData);

    self.rankData = ko.observable();
    self.onSave = function () {
        self.rankData(JSON.stringify({ rank: self.rank(), rankPrefix: self.rankPrefix() }));
    };

    self.getTimeStamp = function () {
        return Math.max(self.rankPrefix.getTimeStamp(), self.rank.getTimeStamp());
    };
};

window.RankForm = RankForm;

var ServingName = function (data, parent) {
    var self = this;
    self.id = ko.observable(data['id']);
    self.name = ko.observableTS(data['name']);
    self.namePrefix = ko.observableTS(data['namePrefix']);
    self.position = ko.observableTS(data['position']);
    self.type = ko.observableTS(data['type']);
    self.deleted = ko.observable(false);
    self.parent = parent;

    self.first = ko.computed(function () {
        return parent.first(self);
    });
    self.last = ko.computed(function () {
        return parent.last(self);
    });

    self.onDelete = function () {
        self.deleted(!self.deleted());
    };

    self.dump = function () {
        return {
            id: self.id(),
            name: self.name(),
            namePrefix: self.namePrefix(),
            position: self.position(),
            type: self.type(),
            deleted: self.deleted(),
        };
    };

    self.getTimeStamp = function () {
        return Math.max(
            self.namePrefix.getTimeStamp(),
            self.name.getTimeStamp(),
            self.type.getTimeStamp(),
            self.position.getTimeStamp()
        );
    };
};

var ServingNameForm = function (data) {
    var self = this;
    self.types = data['types'];
    self.sex = ko.observable(data['sex']);

    self.names = ko.observableArray([]);
    self.servingNamesData = ko.observable();

    self.autocompleteMonkName = ko.computed(function () {
        return ko.observable(
            '/cabinet/ajax/autocomplete/monk_name/?query=%QUERY&sex=' + self.sex()
        );
    });

    var sortNames = function (l, r) {
        return l.position() - r.position();
    };

    var swap = function (o1, o2) {
        var pos = o1.position();
        o1.position(o2.position());
        o2.position(pos);
        self.names.sort(sortNames);
    };

    self.last = function (o) {
        if (self.names().length <= 1) return true;
        var arr = self.names();
        var last = arr[arr.length - 1];
        return last == o;
    };

    self.first = function (o) {
        if (self.names().length <= 1) return true;
        return self.names()[0] == o;
    };

    self.names(
        data['person_serving_names'].map(function (v) {
            return new ServingName(v, self);
        })
    );
    self.names.sort(sortNames);

    self.onUp = function (o) {
        var arr = self.names();
        for (var i = 0; i < arr.length; i++) {
            if (arr[i] == o && i > 0) {
                swap(arr[i], arr[i - 1]);
                break;
            }
        }
        console.log($(event.target).closest('movable-js'));
    };

    self.onDown = function (o) {
        var arr = self.names();
        for (var i = 0; i < arr.length; i++) {
            if (arr[i] == o && i < arr.length - 1) {
                swap(arr[i], arr[i + 1]);
                break;
            }
        }
    };

    self.onAdd = function () {
        var names = self.names();
        var next = 0;
        if (names.length > 0) var next = names[names.length - 1].position() + 1;
        self.names.push(new ServingName({ position: next }, self));
    };

    self.onSave = function () {
        var d = JSON.stringify(
            self.names().map(function (n) {
                return n.dump();
            })
        );
        self.servingNamesData(d);
    };

    self.countNames = function () {
        return self.names().reduce(function (c, v) {
            if (v.name() && !v.deleted()) return c + 1;
            return c;
        });
    };

    self.getNameList = function () {
        return self
            .names()
            .filter(function (v) {
                return v.name() && !v.deleted();
            })
            .map(function (v) {
                return { name: v.name(), prefix: v.namePrefix() };
            });
    };

    self.getTimeStamp = function () {
        return self.names().reduce(function (result, name) {
            return Math.max(result, name.getTimeStamp());
        }, 0);
    };
};

window.ServingNameForm = ServingNameForm;

var DisplayNameForm = function (data) {
    var self = this;
    self.useDisplayName = ko.observable(data['useDisplayName']);
    self.displayName = ko.observableTS(data['displayName']);
    self.displayNameData = ko.observable(data['useDisplayName']);

    self.getTimeStamp = function () {
        return self.displayName.getTimeStamp();
    };

    self.isSet = function () {
        return self.useDisplayName();
    };

    var reloadDisplayName = function () {
        if (!window.namesForm || !window.servingNameForm || !window.rankForm) return;

        var addPrefix = function (v) {
            return (v.name ? v.name : '') + (v.prefix ? ' (?)' : '');
        };

        var cleanBrackets = function (v) {
            return ' (' + v + ')';
        };

        var buildNameList = function (names) {
            names = names.map(addPrefix);
            if (names.length == 0) return null;
            else if (names.length == 1) return names[0];
            return names[0] + cleanBrackets(names.slice(1).join(', '));
        };

        var surname = buildNameList(window.namesForm.surnames.getNameList());
        var name = buildNameList(window.namesForm.names.getNameList());
        var secondName = buildNameList(window.namesForm.secondNames.getNameList());
        var monkName = buildNameList(window.servingNameForm.getNameList());
        var rankId = window.rankForm.rank() && window.rankForm.rank()['id'];
        var rankName = window.rankForm.rank() && window.rankForm.rank()['name'];
        var rankPrefix = window.rankForm.rank() && window.rankForm.rankPrefix();
        var isMonk = window.rankForm.rank() && window.rankForm.rank()['isMonk'];

        var nameList = [];
        if (surname || name || secondName) {
            if (!surname && !name) nameList = ['[Фамилия и имя неизвестны]', secondName];
            else if (!secondName && !name)
                nameList = [surname, monkName ? null : '[Имя и отчество неизвестны]'];
            else
                nameList = [
                    surname || '[Фамилия неизвестна]',
                    name || '[Имя неизвестно]',
                    secondName,
                ];
        }

        nameList = nameList
            .filter(function (v) {
                return v;
            })
            .join(' ');

        if (monkName) var displayName = monkName + cleanBrackets(nameList);
        else var displayName = nameList;

        if (rankId) {
            var rank = addPrefix({ name: rankName, prefix: rankPrefix });
            if (isMonk && !monkName) rank = rank + ' <i>(имя в постриге неизвестно)</i>';
            displayName += ', ' + rank;
        }

        return displayName;
    };

    self.reloadDisplayName = function () {
        self.displayName(reloadDisplayName());
        self.displayName.updateTimeStamp();
    };

    self.onSave = function () {
        self.displayNameData(
            JSON.stringify({
                useDisplayName: self.useDisplayName(),
                displayName: self.displayName(),
            })
        );
    };

    self.useDisplayName.subscribe(function (value) {
        if (value && !self.displayName()) self.displayName(reloadDisplayName());
    });
};

window.DisplayNameForm = DisplayNameForm;

var SelectionMark = function (data, parent) {
    var self = this;
    self.id = ko.observable(data['id']);
    self.section = ko.observableTS(data['section']);
    self.deleted = ko.observable(false);
    self.parent = parent;

    self.onDelete = function () {
        self.deleted(!self.deleted());
    };

    self.dump = function () {
        return {
            id: self.id(),
            section: self.section(),
            deleted: self.deleted(),
        };
    };
};

var Relative = function (parent, data, availableCommentConnectorTypes, relationTypes) {
    var self = this;
    var selRelationType = null;
    var defaultRelationType = { id: null, name: '--------', sex: null };
    self.id = ko.observable(data['id']);
    self.relPersonId = ko.observable(data['relPersonId']);
    self.relPersonText = ko.observable(data['relPersonText']);
    self.relPersonSex = ko.observable(data['relPersonSex']);
    self.relationTypes = [defaultRelationType].concat(relationTypes);
    self.commentConnector = ko.observable(
        data['commentConnector'] || availableCommentConnectorTypes[0]['id']
    );
    self.comment = ko.observable(data['comment']);
    self.position = ko.observable(data['position']);
    self.toDelete = ko.observable(false);

    for (var i = 0; i < self.relationTypes.length; i++) {
        if (data['relationType'] == self.relationTypes[i]['id']) {
            selRelationType = self.relationTypes[i];
            break;
        }
    }

    self.correctRelationType = ko.observable(true);

    self.relationType = ko.observable(selRelationType || defaultRelationType);
    self.relationType.subscribe(function () {
        self.checkRelationType();
    });

    self.idEnabled = ko.pureComputed(function () {
        return self.relPersonId() || !self.relPersonText();
    });

    self.textEnabled = ko.pureComputed(function () {
        return !self.relPersonId();
    });

    self.correctRelPersonId = ko.observable(true);

    self.relPersonId.subscribe(function () {
        if (!self.relPersonId()) {
            self.correctRelPersonId(true);
            self.relPersonSex(null);
            return;
        }
        if (!isNaN(self.relPersonId())) {
            $.get('/cabinet/ajax/person/' + self.relPersonId() + '/', function (data) {
                self.relPersonText(data.title);
                self.relPersonSex(data.sex);
                self.correctRelPersonId(true);
            }).fail(function () {
                self.relPersonText('');
                self.relPersonSex(null);
                self.correctRelPersonId(false);
            });
        } else {
            self.relPersonSex(null);
            self.correctRelPersonId(false);
        }
        self.checkRelationType();
    });

    self.parent = parent;
    self.availableCommentConnectorTypes = availableCommentConnectorTypes;

    self.first = ko.computed(function () {
        return parent.first(self);
    });
    self.last = ko.computed(function () {
        return parent.last(self);
    });

    self.onDelete = function () {
        self.toDelete(!self.toDelete());
    };

    self.isValidID = ko.computed(function () {
        return (
            !self.relPersonId() ||
            (self.relPersonId() != parent.personId && self.correctRelPersonId())
        );
    });

    self.isEmptyCommentConnector = ko.computed(function () {
        return (
            self.comment() && self.commentConnector() === availableCommentConnectorTypes[0]['id']
        );
    });

    self.checkRelationType = ko.computed(function () {
        if (
            self.relPersonSex() != null &&
            self.relationType()['sex'] != null &&
            self.relationType()['sex'] != self.relPersonSex()
        )
            self.correctRelationType(false);
        else self.correctRelationType(true);
    });

    self.dump = function () {
        return {
            id: self.id(),
            relPersonId: self.relPersonId(),
            relPersonText: self.relPersonText(),
            relationType: self.relationType()['id'],
            commentConnector: self.commentConnector(),
            comment: self.comment(),
            position: self.position(),
            toDelete: self.toDelete(),
        };
    };
};

var RelativesForm = function (relatives_formset) {
    var self = this;
    var availableCommentConnectorTypes = [{ id: null, name: '--------' }].concat(
        relatives_formset['connectorTypes']
    );
    var relationTypes = relatives_formset['relationTypes'];
    self.personId = relatives_formset['personId'];
    self.relatives = ko.observableArray([]);
    self.relativesListData = ko.observable();

    self.onAdd = function () {
        var relatives = self.relatives();
        var next = 0;
        if (relatives.length > 0) var next = relatives[relatives.length - 1].position() + 1;
        self.relatives.push(
            new Relative(self, { position: next }, availableCommentConnectorTypes, relationTypes)
        );
        var elem = jQuery(event.target)
            .closest('.row')
            .prev()
            .find('> .row')
            .last();
        var timer = null;
        timer = setTimeout(function () {
            jQuery('html, body')
                .stop()
                .animate(
                    {
                        scrollTop: elem.offset().top,
                    },
                    200
                );
        }, 200);
    };

    var sortRelatives = function (l, r) {
        return l.position() - r.position();
    };

    var swap = function (o1, o2) {
        var pos = o1.position();
        o1.position(o2.position());
        o2.position(pos);
        self.relatives.sort(sortRelatives);
    };

    self.last = function (o) {
        if (self.relatives().length <= 1) return true;
        var arr = self.relatives();
        var last = arr[arr.length - 1];
        return last == o;
    };

    self.first = function (o) {
        if (self.relatives().length <= 1) return true;
        return self.relatives()[0] == o;
    };

    self.onUp = function (o, event) {
        var elem = jQuery(event.target).closest('.movable-js');
        var yBottom = jQuery(event.target).offset().top;
        var yTop = $(elem)
            .prev()
            .find('.btn-move-down-js')
            .offset().top;
        var y = $(window).scrollTop();
        var deltaY = yBottom - yTop;
        var timer = null;

        if ($(window).scrollTop() > deltaY) {
            jQuery('html, body')
                .stop()
                .animate(
                    {
                        scrollTop: y - deltaY,
                    },
                    200
                );

            elem.css('box-shadow', '0px 0px 10px 3px rgba(255,247,92,1)');
            timer = setTimeout(function () {
                elem.css({
                    'box-shadow': 'none',
                });
            }, 500);
        } else {
            jQuery('html, body')
                .stop()
                .animate(
                    {
                        scrollTop: y - $(window).scrollTop(),
                    },
                    200
                );

            elem.css('box-shadow', '0px 0px 10px 3px rgba(255,247,92,1)');
            timer = setTimeout(function () {
                elem.css({
                    'box-shadow': 'none',
                });
            }, 2500);
        }

        var arr = self.relatives();
        for (var i = 0; i < arr.length; i++) {
            if (arr[i] == o && i > 0) {
                swap(arr[i], arr[i - 1]);
                break;
            }
        }
    };

    self.onDown = function (o, event) {
        var elem = jQuery(event.target).closest('.movable-js');
        var yTop = jQuery(event.target).offset().top;
        var yBottom = $(elem)
            .next()
            .find('.btn-move-down-js')
            .offset().top;
        var y = $(window).scrollTop();
        var deltaY = yBottom - yTop;
        var timer = null;

        if ($(window).scrollTop() + $(window).height() > deltaY) {
            jQuery('html, body')
                .stop()
                .animate(
                    {
                        scrollTop: y + deltaY,
                    },
                    200
                );

            elem.css('box-shadow', '0px 0px 10px 3px rgba(255,247,92,1)');
            timer = setTimeout(function () {
                elem.css({
                    'box-shadow': 'none',
                });
            }, 500);
        } else {
            elem.css('box-shadow', '0px 0px 10px 3px rgba(255,247,92,1)');
            timer = setTimeout(function () {
                elem.css({
                    'box-shadow': 'none',
                });
            }, 2500);
        }

        var arr = self.relatives();
        for (var i = 0; i < arr.length; i++) {
            if (arr[i] == o && i < arr.length - 1) {
                swap(arr[i], arr[i + 1]);
                break;
            }
        }
    };

    self.relatives(
        relatives_formset['relatives'].map(function (r) {
            return new Relative(self, r, availableCommentConnectorTypes, relationTypes);
        })
    );

    self.onSave = function () {
        var d = JSON.stringify(
            self.relatives().map(function (r) {
                return r.dump();
            })
        );
        self.relativesListData(d);
    };

    self.correctRelPersonId = function () {
        return self.relatives().some(function (v) {
            return !v.correctRelPersonId() && !v.toDelete();
        });
    };

    self.correctRelationType = function () {
        return self.relatives().some(function (v) {
            return !v.correctRelationType() && !v.toDelete();
        });
    };

    self.selfRelative = function () {
        return self.relatives().some(function (v) {
            return self.personId && self.personId == v.relPersonId() && !v.toDelete();
        });
    };

    self.duplicateRelative = function () {
        var ids = self
            .relatives()
            .filter(function (obj) {
                return !obj.toDelete();
            })
            .map(function (obj) {
                return obj.relPersonId();
            });

        var countedIds = ids.reduce(function (allIds, id) {
            if (id) {
                if (id in allIds) allIds[id]++;
                else allIds[id] = 1;
            }
            return allIds;
        }, {});

        console.log(countedIds);

        // return Object.keys(countedIds).filter((obj) => countedIds[obj] > 1);
        return Object.keys(countedIds).filter(function (obj) {
            return countedIds[obj] > 1;
        });
    };

    self.emptyCommentConnector = function () {
        return self.relatives().some(function (v) {
            return v.isEmptyCommentConnector() && !v.toDelete();
        });
    };
    //
    //    self.relativeIsEmpty= function() {
    //        return self.relatives().some(function(v) { return !v.relPersonId() && !v.relPersonText() && !v.toDelete(); });
    //    }
};

window.RelativesForm = RelativesForm;

var Persecution = function(data, parent) {
    var self = this;

    self.id = ko.observable(data['id']);
    self.editUrl = ko.observable(data['editUrl']);
    self.dates = ko.observable(data['dates']);
    self.details = ko.observable(data['details']);
    self.position = ko.observable(data['position']);
    self.deleted = ko.observable(false);
    self.parent = parent;

    self.first = ko.computed(function() {
        return parent.first(self);
    });
    self.last = ko.computed(function() {
        return parent.last(self);
    });

    self.onDelete = function() {
        parent.unchanged(false);
        self.deleted(!self.deleted());
    };

    self.dump = function() {
        return {
            id: self.id(),
            position: self.position(),
            deleted: self.deleted(),
        };
    };
};

var PersecutionForm = function(data) {
    var self = this;

    self.personId = data['personId'];
    self.sandbox = data['sandbox'];
    self.persecutions = ko.observableArray([]);
    self.unchanged = ko.observable(true);

    var sortPositions = function(l, r) {
        return l.position() - r.position();
    };

    var swap = function(o1, o2) {
        var pos = o1.position();
        o1.position(o2.position());
        o2.position(pos);
        self.persecutions.sort(sortPositions);
        self.unchanged(false);
    };

    self.last = function(o) {
        if (self.persecutions().length <= 1) return true;
        var arr = self.persecutions();
        var last = arr[arr.length - 1];
        return last == o;
    };

    self.first = function(o) {
        if (self.persecutions().length <= 1) return true;
        return self.persecutions()[0] == o;
    };

    self.persecutions(
        data['personPersecutions'].map(function(v) {
            return new Persecution(v, self);
        })
    );
    self.persecutions.sort(sortPositions);

    self.onUp = function(o) {
        var arr = self.persecutions();
        for (var i = 0; i < arr.length; i++) {
            if (arr[i] == o && i > 0) {
                swap(arr[i], arr[i - 1]);
                break;
            }
        }
        console.log($(event.target).closest('movable-js'));
    };

    self.onDown = function(o) {
        var arr = self.persecutions();
        for (var i = 0; i < arr.length; i++) {
            if (arr[i] == o && i < arr.length - 1) {
                swap(arr[i], arr[i + 1]);
                break;
            }
        }
    };

    self.onSave = function(o) {
        $.ajax({
            url: '/cabinet/api/persons/persecutions/save/',
            type: 'POST',
            dataType: 'json',
            data: JSON.stringify({
                personId: self.personId,
                sandbox: self.sandbox,
                data: self.persecutions().map(function(p) {return p.dump();})
            }),
            error: function(jqXHR, textStatus, errorThrown) {
                alert('Произошла ошибка сохранения раздела "Преследования"');
            },
        }).done(function() {
            var arr = self.persecutions();
            arr = arr.filter(function(item) {
                return !item.deleted();
            });
            self.persecutions(arr);
            self.unchanged(true);
        })
    };
};

window.PersecutionForm = PersecutionForm;


var ServingPlace = function(data, parent) {
    var self = this;

    self.id = ko.observable(data['id']);
    self.editUrl = ko.observable(data['editUrl']);
    self.startDate = ko.observable(data['startDate']);
    self.endDate = ko.observable(data['endDate']);
    self.equalDates = ko.observable(data['equalDates']);
    self.info = ko.observable(data['info']);
    self.position = ko.observable(data['position']);
    self.type = ko.observable(data['type']);
    self.deleted = ko.observable(false);
    self.parent = parent;

    self.first = ko.computed(function() {
        return parent.first(self);
    });
    self.last = ko.computed(function() {
        return parent.last(self);
    });

    self.onDelete = function() {
        self.deleted(!self.deleted());
    };

    self.dump = function() {
        return {
            id: self.id(),
            position: self.position(),
            deleted: self.deleted(),
        };
    };
};

var ServingPlaceForm = function(data) {
    var self = this;

    self.personId = data['personId'];
    self.places = ko.observableArray([]);

    var sortPlaces = function(l, r) {
        return l.position() - r.position();
    };

    var swap = function(o1, o2) {
        var pos = o1.position();
        o1.position(o2.position());
        o2.position(pos);
        self.places.sort(sortPlaces);
    };

    self.last = function(o) {
        if (self.places().length <= 1) return true;
        var arr = self.places();
        var last = arr[arr.length - 1];
        return last == o;
    };

    self.first = function(o) {
        if (self.places().length <= 1) return true;
        return self.places()[0] == o;
    };

    self.places(
        data['personServingPlaces'].map(function(v) {
            return new ServingPlace(v, self);
        })
    );
    self.places.sort(sortPlaces);

    self.onUp = function(o) {
        var arr = self.places();
        for (var i = 0; i < arr.length; i++) {
            if (arr[i] == o && i > 0) {
                swap(arr[i], arr[i - 1]);
                break;
            }
        }
        console.log($(event.target).closest('movable-js'));
    };

    self.onDown = function(o) {
        var arr = self.places();
        for (var i = 0; i < arr.length; i++) {
            if (arr[i] == o && i < arr.length - 1) {
                swap(arr[i], arr[i + 1]);
                break;
            }
        }
    };

    self.onSave = function(o) {
        $.ajax({
            url: '/cabinet/api/persons/serving_places/save/',
            type: 'POST',
            dataType: 'json',
            data: JSON.stringify({
                personId: self.personId,
                data: self.places().map(function(p) {return p.dump();})
            }),
            error: function(jqXHR, textStatus, errorThrown) {
                alert('Произошла ошибка сохранения раздела "Места служения"');
            },
        }).done(function() {
            var dialog = $('<p>Данные раздела "Места служения" успешно сохранены</p>.').dialog({
                dialogClass: 'no-close',
                closeText: null,
                width: 400,
                buttons: [
                    {
                        text: 'OK',
                        click: function() {
                            $(this).dialog('close');
                        },
                    },
                ],
            });

            var arr = self.places();
            arr = arr.filter(function(item) {
                return !item.deleted();
            });
            self.places(arr);
        })
    };
};

window.ServingPlaceForm = ServingPlaceForm;


var Material = function(parent, data, availableTypes) {
    var self = this;
    self.id = ko.observable(data['id']);
    self.materialId = ko.observable(data['materialId']);
    self.materialText = ko.observable(data['materialText']);
    self.pages = ko.observable(data['pages']);
    self.type = ko.observable(data['type'] || availableTypes[0]['id']);
    self.display = ko.observable(data['display']);
    self.toDelete = ko.observable(false);

    self.idEnabled = ko.observable(true);
    self.textEnabled = ko.observable(true);
    self.correctMaterialId = ko.observable(true);

    if (self.materialId()) {
        self.textEnabled(false);
    } else {
        if (self.materialText()){
            self.idEnabled(false);
        };
    };

    self.onBlurId = function (d, e) {
        self.getMaterialById();
    };

    self.onChangeId = function (d, e) {
        if (e.keyCode === 13) {
            self.getMaterialById();
        } else {
            self.correctMaterialId(true);
            return true;
        };
    };

    self.materialId.subscribe(function (newValue) {
        self.textEnabled(!newValue);
        self.materialText('');
    });

    self.materialText.subscribe(function (newValue) {
        if (newValue) {
            self.idEnabled(!!self.materialId());
        }
        else {
            self.idEnabled(true);
        };
    });

    self.getMaterialById = function () {
        if (!self.materialId()) {
            self.correctMaterialId(true);
            self.materialId(null);
            self.materialText('');
            self.textEnabled(true);
            return;
        }

        if (!isNaN(self.materialId())) {
            $.ajax({
                url: '/cabinet/ajax/material/' + self.materialId() + '/',
                success: function(data) {
                    self.materialText(data.name);
                    self.correctMaterialId(true);
                },
                async: false,
            }).fail(function () {
                self.materialText('');
                self.correctMaterialId(false);
            });
        } else self.correctMaterialId(false);
    };

    self.onDelete = function () {
        self.toDelete(!self.toDelete());
    };

    self.isValidID = ko.computed(function () {
        return !self.materialId() || self.correctMaterialId();
    });

    self.parent = parent;
    self.availableTypes = availableTypes;

    self.dump = function () {
        return {
            id: self.id(),
            materialId: self.materialId(),
            materialText: self.materialText(),
            pages: self.pages(),
            type: self.type(),
            display: self.display(),
            toDelete: self.toDelete(),
        };
    };

    self.onMaterialSelected = function (obj) {
        self.materialId(obj.materialId());
    };

    self.searchMaterial = function () {
        if (window.searchMaterialForm) {
            $('#searchMaterial').modal('show');
            window.searchMaterialForm.currentForm = self;
            window.searchMaterialForm.materialAuthors(parent.materialAuthors);
        }
    };
};

var MaterialsForm = function (person_material_formset) {
    var self = this;
    var availableTypes = [{ id: null, name: '--------' }].concat(person_material_formset['types']);
    self.materialAuthors = [{ id: null, name: '--------' }].concat(
        person_material_formset['material_authors']
    );
    self.personMaterials = ko.observableArray([]);
    self.personMaterialsListData = ko.observable();

    self.onAdd = function () {
        self.personMaterials.push(new Material(self, { display: true }, availableTypes));
        var elem = jQuery(event.target)
            .closest('.row')
            .prev()
            .find('> .row')
            .last();
        var timer = null;
        timer = setTimeout(function () {
            jQuery('html, body')
                .stop()
                .animate(
                    {
                        scrollTop: elem.offset().top,
                    },
                    200
                );
        }, 200);
    };

    self.personMaterials(
        person_material_formset['person_materials'].map(function (m) {
            return new Material(self, m, availableTypes);
        })
    );

    self.onSave = function () {
        var d = JSON.stringify(
            self.personMaterials().map(function (m) {
                return m.dump();
            })
        );
        self.personMaterialsListData(d);
    };

    self.materialTypeIsEmpty = function () {
        return self.personMaterials().some(function (v) {
            return v.type() === null && !v.toDelete();
        });
    };

    self.materialIsEmpty = function () {
        return self.personMaterials().some(function (v) {
            return !v.materialId() && !v.materialText() && !v.toDelete();
        });
    };

    self.correctMaterialId = function () {
        return self.personMaterials().some(function (v) {
            return !v.correctMaterialId() && !v.toDelete();
        });
    };
};

window.MaterialsForm = MaterialsForm;

export function exitLock() {
    $(window).bind('beforeunload.sureExit', function (e) {
        return 'Вы уверены, что хотите уйти с этой страницы?';
    });

    $('form.u-person-form').submit(function () {
        $(window).unbind('beforeunload.sureExit');
    });
}

var SearchMaterial = function (data) {
    var self = this;
    self.materialId = ko.observable(data['materialId']);
    self.materialName = ko.observable(data['materialName']);
    self.selected = ko.observable(false);
};

var SearchMaterialForm = function () {
    var self = this;
    self.currentForm = null;
    self.materialAuthors = ko.observableArray();
    self.currentMaterial = ko.observable(null);
    self.searchMaterialId = ko.observable();
    self.searchMaterialText = ko.observable();
    self.searchMaterialAuthor = ko.observable();
    self.materialsList = ko.observableArray();
    self.currentMaterialsList = ko.observableArray();
    self.currentPage = ko.observable(1);
    self.pagesCount = ko.observable(1);
    self.pageLength = 4;

    self.first = ko.computed(function () {
        return self.currentPage() == 1;
    });
    self.current = ko.computed(function (pageNumber) {
        return self.currentPage() == pageNumber;
    });
    self.last = ko.computed(function () {
        return self.currentPage() == self.pagesCount();
    });

    self.allPages = ko.computed(function () {
        var pages = [];
        if (self.pagesCount() <= 10) {
            for (var i = 0; i < self.pagesCount(); i++) {
                pages.push({ pageNumber: i + 1 });
            }
        } else {
            if (self.currentPage() < 7) {
                for (var i = 1; i < 8; i++) {
                    pages.push({ pageNumber: i });
                }
                pages.push({ pageNumber: '...' });
                pages.push({ pageNumber: self.pagesCount() - 1 });
                pages.push({ pageNumber: self.pagesCount() });
            } else if (self.currentPage() > self.pagesCount() - 6) {
                pages.push({ pageNumber: 1 });
                pages.push({ pageNumber: 2 });
                pages.push({ pageNumber: '...' });
                for (var i = self.pagesCount() - 6; i <= self.pagesCount(); i++) {
                    pages.push({ pageNumber: i });
                }
            } else {
                pages.push({ pageNumber: 1 });
                pages.push({ pageNumber: 2 });
                pages.push({ pageNumber: '...' });
                for (var i = self.currentPage() - 2; i <= self.currentPage() + 2; i++) {
                    pages.push({ pageNumber: i });
                }
                pages.push({ pageNumber: '...' });
                pages.push({ pageNumber: self.pagesCount() - 1 });
                pages.push({ pageNumber: self.pagesCount() });
            }
        }
        return pages;
    });

    self.setCurrentMaterials = function () {
        var f_pos = (self.currentPage() - 1) * self.pageLength;
        var l_pos = Math.min(self.currentPage() * self.pageLength, self.materialsList().length);

        self.currentMaterialsList(self.materialsList().slice(f_pos, l_pos));
    };

    self.onPage = function (pageNumber) {
        if (self.currentForm) {
            if (pageNumber >= 1 && pageNumber <= self.pagesCount()) {
                self.currentPage(pageNumber);
                self.setCurrentMaterials();
            }
        }
    };

    self.onLeft = function () {
        if (self.currentForm) {
            if (self.currentPage() > 1) {
                self.currentPage(self.currentPage() - 1);
                self.setCurrentMaterials();
            }
        }
    };

    self.onRight = function () {
        if (self.currentForm) {
            if (self.currentPage() < self.pagesCount()) {
                self.currentPage(self.currentPage() + 1);
                self.setCurrentMaterials();
            }
        }
    };

    self.select = function (obj) {
        if (self.currentMaterial()) self.currentMaterial().selected(false);
        self.currentMaterial(obj);
        obj.selected(true);
    };

    self.onOk = function () {
        if (self.currentForm) {
            if (self.currentMaterial()) self.currentForm.onMaterialSelected(self.currentMaterial());
            self.onReset();
            $('#searchMaterial').modal('hide');
        }
    };

    self.onReset = function () {
        if (self.currentForm) {
            self.searchMaterialId(null);
            self.searchMaterialText(null);
            self.searchMaterialAuthor(null);
            self.materialsList([]);
            self.currentMaterialsList([]);
            self.currentPage(1);
            self.pagesCount(1);
            if (self.currentMaterial()) {
                self.currentMaterial().selected(false);
                self.currentMaterial(null);
            }
        }
    };

    self.onEnter = function (d, e) {
        if (e.keyCode === 13) {
            if (self.searchMaterialText() || self.searchMaterialAuthor() || self.searchMaterialId())
                self.onSearch();
            else self.onReset();
        } else return true;
    };

    self.search = function () {
        self.currentPage(1);
        self.currentMaterialsList([]);
        $.get('/cabinet/material/search/', {
            id: self.searchMaterialId(),
            name: self.searchMaterialText(),
            author: self.searchMaterialAuthor(),
        }).done(function (data) {
            self.materialsList(
                data['materials'].map(function (v) {
                    return new SearchMaterial(v);
                })
            );
            var count = self.materialsList().length;
            var wPages = (count / self.pageLength) >> 0;
            if (count % self.pageLength > 0) self.pagesCount(wPages + 1);
            else self.pagesCount(wPages);
            self.setCurrentMaterials();
        });
    };

    self.onSearch = function () {
        if (self.currentForm) {
            if (self.searchMaterialId() || self.searchMaterialText() || self.searchMaterialAuthor())
                self.search();
        }
    };
};

window.SearchMaterialForm = SearchMaterialForm;

var process_exit = function (e) {
    return process_exit_action(e, 'save');
};

var process_exit_redirect = function (e) {
    return process_exit_action(e, 'save-and-redirect');
};

var process_exit_new = function(e) {
    return process_exit_action(e, 'save-and-new');
};

var SubmitLock = function() {
    var self = this;
    self._lock = false;

    self.lock = function() {
        $('.u-save-person, .u-save-person-close, .u-save-person-new').attr('disabled', 'disabled');
        self._lock = true;
    };

    self.unlock = function() {
        $('.u-save-person, .u-save-person-close, .u-save-person-new').removeAttr('disabled');
        self._lock = false;
    };

    self.locked = function () {
        return self._lock;
    };
};

var getFormData = function (formName) {
    var data = {};

    switch (formName) {
        case 'serving':
            data['formClass'] = '.u-serving-form';
            data['formIdPrefix'] = 'serving-form-';
            data['idPrefix'] = 'id_serving_places-';
            break;
        case 'award':
            data['formClass'] = '.u-award-form';
            data['formIdPrefix'] = 'award-form-';
            data['idPrefix'] = 'id_awards-';
            break;
        case 'ordination':
            data['formClass'] = '.u-ordination-form';
            data['formIdPrefix'] = 'ordination-form-';
            data['idPrefix'] = 'id_ordinations-';
            break;
        case 'persecution':
            data['formClass'] = '.u-persecuted-form';
            data['formIdPrefix'] = 'persecuted-form-';
            data['idPrefix'] = 'id_persecutions-';
            break;
        default:
            data['formClass'] = null;
            data['formIdPrefix'] = null;
            data['idPrefix'] = null;
            break;
    }

    data['formName'] = formName;
    return data;
};

var checkServingCommentConnector = function (backToEdit, submitForm) {
    return checkFormsetCommentConnector(backToEdit, getFormData('serving'));
};

var checkAwardCommentConnector = function (backToEdit, submitForm) {
    return checkFormsetCommentConnector(backToEdit, getFormData('award'));
};

var checkOrdinationCommentConnector = function (backToEdit, submitForm) {
    return checkFormsetCommentConnector(backToEdit, getFormData('ordination'));
};

var checkPersecutedCommentConnector = function (backToEdit, submitForm) {
    return checkFormsetCommentConnector(backToEdit, getFormData('persecution'));
};

var checkPersecutedNewCommentConnector = function(backToEdit, submitForm) {
    var type = document.getElementById('id_type').value;
    var fullIdPrefix = type + '_id';
    return checkCommentConnector(backToEdit, null, fullIdPrefix + '_comment', fullIdPrefix + '_comment_connector');
};

var checkInfoCommentConnectors = function(backToEdit, submitForm) {
    var ids = [
        {
            commentId: 'id_birthday_comment',
            commentConnectorId: 'id_birthday_comment_connector',
        },
        {
            commentId: 'id_death_date_comment',
            commentConnectorId: 'id_death_date_comment_connector',
        },
        {
            commentId: 'id_birthday_place_address',
            commentConnectorId: 'id_birthday_place_address_connector',
        },
        {
            commentId: 'id_death_place_address',
            commentConnectorId: 'id_death_place_address_connector',
        },
    ];

    for (var i = 0; i < ids.length; i++) {
        if (
            !checkCommentConnector(
                backToEdit,
                null,
                ids[i]['commentId'],
                ids[i]['commentConnectorId']
            )
        )
            return false;
    }
    return true;
};

var commentConnectorErrorDialog = function (backToEdit) {
    var dialog = $(
        '<p>Если поле "Текст комментария" не пустое, то поле "Комментарий присоединяется через" должно быть заполнено</p>'
    ).dialog({
        modal: true,
        buttons: {
            'Вернуться к редактированию': backToEdit,
        },
        close: backToEdit,
    });
};

var checkFormsetCommentConnector = function (backToEdit, data) {
    var fullIdPrefix = data['idPrefix'];

    for (var i = 0, max = $(data['formClass']).length; i < max; i++) {
        if (data['formName'] == 'persecution') {
            var type = document.getElementById(data['idPrefix'] + i + '-type').value;
            if (type) fullIdPrefix = type + '_' + data['idPrefix'];
        }
        if (
            !checkCommentConnector(
                backToEdit,
                data['idPrefix'] + i + '-DELETE',
                fullIdPrefix + i + '-comment',
                fullIdPrefix + i + '-comment_connector'
            )
        )
            return false;
    }
    return true;
};

var checkCommentConnector = function (backToEdit, deleteOptionId, commentId, commentConnectorId) {
    if (deleteOptionId) {
        var deleteOption = document.getElementById(deleteOptionId);
        if (deleteOption && deleteOption.checked) return true;
    }

    var comment = document.getElementById(commentId);
    if (comment && comment.value) {
        var commentConnector = document.getElementById(commentConnectorId);
        if (commentConnector && commentConnector.value === '') {
            var commentConnectorGroup = commentConnector.parentElement;
            if (commentConnectorGroup) {
                commentConnectorGroup.classList.add('has-error');
                var spanWarningSign = commentConnectorGroup.lastElementChild;
                if (spanWarningSign) {
                    spanWarningSign.classList.remove('hidden');
                    spanWarningSign.classList.add('glyphicon', 'glyphicon-warning-sign');
                }
            }
            commentConnectorErrorDialog(backToEdit);
            return false;
        }
    }
    return true;
};

var checkBirthDate = function (backToEdit, submitForm) {
    if (
        !$('#id_birthday_date_month').val() &&
        !$('#id_birthday_date_day').val() &&
        !$('#id_birthday_date_year').val() &&
        !$('#id_birthday_date2_month').val() &&
        !$('#id_birthday_date2_day').val() &&
        !$('#id_birthday_date2_year').val()
    ) {
        var dialog = $(
            '<p>Дата рождения должна быть заполнена. Вернуться к редактированию?</p>'
        ).dialog({
            closeText: null,
            modal: true,
            buttons: {
                'Да, вернуться к редактированию': backToEdit,
                'Нет, заполнить эти позиции позже': submitForm,
            },
            close: backToEdit,
        });
        return false;
    }
    return true;
};
/**

 * @desc runs on first save in session
 * @param submitForm
 * @returns {boolean}  
 */

var checkFirst = function (backToEdit, submitForm) {
    var currentUser = $('.user-name').text();
    var modalText =
        'Вы работаете над страницей персоны, обладающей статусом ' +
        '«Просмотр научного редактора не требуется». Не забудьте изменить этот статус,' +
        ' если в процессе дальнейшей работы, по Вашему мнению, он должен измениться на:' +
        ' «Нуждается в научном редактировании» (т. е. если будет вноситься информация о ' +
        'принадлежности к церковным расколам или церковным юрисдикциям, отличным от «РПЦ МП»; ' +
        'о снятии или лишении сана; если будет неуверенность том, какой именно и был ли вообще ' +
        'священный сан, неясность в отношении наличия канонических препятствий (в частности, второй брак), ' +
        'негативная информации в отношении поведения на следствии (сотрудничество с органами, оговор других)' +
        ' или другая негативная информация или другая информация, о которой можно предположить, что лучше, чтобы ' +
        'ее оценил научный редактор).';

    var data = '';
    var id = $('.nav-tabs')
        .find('li.active')
        .find('a')
        .data('id');

    var currentPerson = id;

    if (
        sessionStorage.getItem(currentUser) === null ||
        sessionStorage.getItem(currentPerson) === null
    ) {
        sessionStorage.setItem(currentUser, 'false');
        sessionStorage.setItem(currentPerson, false);
        data = {
            isFirst: true,
            objId: id,
        };
    } else {
        data = {
            isFirst: false,
            objId: id,
        };
    }

    $.ajax({
        type: 'POST',
        url: '/cabinet/editor/get_warn_on_save_state/',
        data: data,
    })
        .done(function (res) {
            if (res.state) {
                var dialog = $('<p>' + modalText + '</p>').dialog({
                    closeText: null,
                    modal: true,
                    buttons: {
                        OK: submitForm,
                    },
                    minWidth: 590,
                    close: submitForm,
                });
                return false;
            }
            if (submitAction === 'save-and-redirect') {
                sessionStorage.setItem(SCROLL_TO_EDIT, 'true');
            }
            $('#action').attr('name', submitAction); //триггер отправки формы, дублирует функции (1)
            $('form.u-person-form').submit();
        })
        .fail(function (event) {
            console.log(event);
        });

    // return true;
};

var checkDeathDate = function (backToEdit, submitForm) {
    if (
        !$('#id_death_date_month').val() &&
        !$('#id_death_date_day').val() &&
        !$('#id_death_date_year').val() &&
        !$('#id_death_date2_month').val() &&
        !$('#id_death_date2_day').val() &&
        !$('#id_death_date2_year').val()
    ) {
        var dialog = $(
            '<p>Дата cмерти должна быть заполнена. Вернуться к редактированию?</p>'
        ).dialog({
            closeText: null,
            modal: true,
            buttons: {
                'Да, вернуться к редактированию': backToEdit,
                'Нет, заполнить эти позиции позже': submitForm,
            },
            close: backToEdit,
        });
        return false;
    }
    return true;
};

var checkServingRank = function (backToEdit, submitForm) {
    var emptyRanks = 0;

    $.each($('.u-serving-form-church-rank').find('select'), function (idx) {
        if (!$(this).val()) emptyRanks++;
    });
    if (emptyRanks) {
        var dialog = $(
            '<p>Не заполнено поле "Сан" в месте служения, которое в большинстве случаев не должно быть ' +
            'пустым. Вернуться к редактированию?</p>'
        ).dialog({
            closeText: null,
            modal: true,
            buttons: {
                'Да, вернуться к редактированию': backToEdit,
                'Нет, заполнить эти позиции позже': submitForm,
            },
            close: backToEdit,
        });
        return false;
    }
    return true;
};

var checkServingEparchy = function (backToEdit, submitForm) {
    var emptyEparchy = 0;

    $.each($('.u-serving-form-eparchy').find('input.tt-input'), function (idx) {
        var text = $(this)
            .val()
            .toLowerCase();
        if (
            text &&
            !['епархия', 'митрополия', 'викариатство', 'округ']
                .map(function (w) {
                    return text.indexOf(w) > -1;
                })
                .some(function (v) {
                    return v;
                })
        )
            emptyEparchy++;
    });
    if (emptyEparchy) {
        var dialog = $(
            "<p>Поле 'Епархия' содержит неполное название. Полное название должно содержать слова: " +
            'епархия, митрополия, викариатство, округ. Вернуться к редактированию?</p>'
        ).dialog({
            closeText: null,
            modal: true,
            buttons: {
                'Да, вернуться к редактированию': backToEdit,
                'Нет, заполнить эти позиции позже': submitForm,
            },
            close: backToEdit,
        });
        return false;
    }
    return true;
};

var checkMaterialPages = function (backToEdit, submitForm) {
    var wrongPages = 0;

    $.each($('.u-material-person-pages'), function (idx) {
        var text = $(this)[0].firstElementChild.value.toLowerCase();
        if (
            text &&
            !['С.', 'Стб.', 'Л.', '№', 'Т.', 'Ч.'].some(function (w) {
                return text.indexOf(w.toLowerCase()) > -1;
            })
        )
            wrongPages++;
    });
    if (wrongPages) {
        var dialog = $(
            '<p>Поле "Страницы" у присоединяемого материала должно содержать указание на страницы,' +
            " листы, номера и др. с буквенными обозначениями ('С. 12', 'Л. 8–9об.', '№ 1. С. 5' и т. п.)." +
            ' Вернуться к редактированию?</p>'
        ).dialog({
            closeText: null,
            modal: true,
            buttons: {
                'Да, вернуться к редактированию': backToEdit,
                'Нет, заполнить эти позиции позже': submitForm,
            },
            close: backToEdit,
        });
        return false;
    }
    return true;
};

var checkPersonRank = function (backToEdit) {
    var rank = window.rankForm.rank();
    var isPrimary = window.rankForm.isPrimary;
    if (isPrimary && (!rank || !rank.id)) {
        var dialog = $("<p>Поле 'Сан' должно быть заполнено.</p>").dialog({
            closeText: null,
            modal: true,
            buttons: {
                'Вернуться к редактированию': backToEdit,
            },
            close: backToEdit,
        });
        return false;
    }
    return true;
};

var checkPersonSections = function (backToEdit) {
    if (!window.rankForm.isPrimary) {
        // это будет работать, пока из формы персоны не уберут window.rankForm
        var bryansk_selected = $('#id_bryansk_eparchy').is(':checked');
        var moscow_selected = $('#id_moscow_eparchy').is(':checked');
        var martyr_selected = $('#id_is_martyr').is(':checked');

        if (!bryansk_selected && !moscow_selected && !martyr_selected) {
            var dialog = $(
                '<p>Должна быть выбрана одна из опций "Размещение на тематических страницах" либо опция "Новомученики"</p>'
            ).dialog({
                closeText: null,
                modal: true,
                buttons: {
                    'Вернуться к редактированию': backToEdit,
                },
                close: backToEdit,
            });
            return false;
        }
    }
    return true;
};

var checkServingCountry = function (backToEdit, submitForm) {
    var totalForms = $('#id_serving_places-TOTAL_FORMS').attr('value');

    var isEmpty = null;

    for (var i = 0; i < totalForms; i++) {
        if ($('#id_serving_places-' + i + '-address_country_typeahead').val() === '') {
            isEmpty += 1;
        }
    }
    if (isEmpty !== null) {
        var dialog = $(
            '<p>Не заполнено поле "Страна" в месте служения, которое' +
            ' в большинстве случаев не должно быть пустым. ' +
            'Вернуться к редактированию?</p>'
        ).dialog({
            closeText: null,
            modal: true,
            buttons: {
                'Да, вернуться к редактированию': backToEdit,
                'Нет, заполнить эти позиции позже': submitForm,
            },
            close: backToEdit,
        });
        return false;
    }
    return true;
};

var checkSex = function (backToEdit, submitForm) {
    if (!$('#id_sex').val()) {
        var dialog = $("<p>Поле 'Пол' должно быть заполнено.</p>").dialog({
            closeText: null,
            modal: true,
            buttons: {
                'Вернуться к редактированию': backToEdit,
            },
            close: backToEdit,
        });
        return false;
    }
    return true;
};

var checkSection = function(backToEdit, submitForm) {
    var bryansk_selected = $('#id_bryansk_eparchy').is(':checked');
    var moscow_selected = $('#id_moscow_eparchy').is(':checked');
    var martyr_selected = $('#id_is_martyr').is(':checked');

    if (!bryansk_selected && !moscow_selected && !martyr_selected) {
        var dialog = $(
            '<p>Должна быть выбрана одна из опций "Размещение на тематических страницах" либо опция "Новомученики"</p>'
        ).dialog({
            closeText: null,
            modal: true,
            buttons: {
                'Вернуться к редактированию': backToEdit,
            },
            close: backToEdit,
        });
        return false;
    }
    return true;
};

var checkMonkNameRankCompatible = function(backToEdit, submitForm) {
    var rank = window.rankForm.rank(),
        rankId = rank && rank.id,
        isPrimary = window.rankForm.isPrimary,
        servingNames = window.servingNameForm.names().filter(function (n) {
            return !n.deleted() && n.name() && n.name().trim() !== '';
        });

    if (isPrimary && servingNames.length > 0 && rankId && !rank.isMonk) {
        var dialog = $(
            '<p>Возможно, сделана ошибка: Заполнено монашеское имя, но проставлен немонашеский сан.</p>'
        ).dialog({
            closeText: null,
            modal: true,
            buttons: {
                'Вернуться к редактированию': backToEdit,
                'Игнорировать и сохранить как есть': submitForm,
            },
            close: backToEdit,
        });
        return false;
    }

    if (!isPrimary && servingNames.length > 0 && !rankId) {
        var dialog = $('<p>Заполнено монашеское имя, но не проставлен сан.</p>').dialog({
            closeText: null,
            modal: true,
            buttons: {
                'Вернуться к редактированию': backToEdit,
            },
            close: backToEdit,
        });
        return false;
    }

    return true;
};

var checkDisplayNameChangedState = function (backToEdit, submitForm) {
    var namesForm = window.namesForm,
        rankForm = window.rankForm,
        servingNameForm = window.servingNameForm,
        displayNameForm = window.displayNameForm,
        namesTS = Math.max(
            namesForm.getTimeStamp(),
            rankForm.getTimeStamp(),
            servingNameForm.getTimeStamp()
        ),
        displayNameTS = displayNameForm.getTimeStamp();

    if (displayNameForm.isSet() && displayNameTS < namesTS) {
        var dialog = $(
            '<p>Возможно, сделана ошибка: Внесены изменения в поля имён и сана, но не корректировалось поле "Отображать имя как" (или корректировалось до изменения имён и сана).</p>'
        ).dialog({
            closeText: null,
            modal: true,
            buttons: {
                'Вернуться к редактированию': backToEdit,
                'Игнорировать и сохранить как есть': submitForm,
            },
            close: backToEdit,
        });
        return false;
    }
    return true;
};

var checkRelativePersonId = function (backToEdit) {
    if (!window.relativesForm) return true;

    if (window.relativesForm.correctRelPersonId()) {
        var dialog = $(
            '<p>Проверьте правильность создания записи. Указан ID несуществующей персоны.</p>'
        ).dialog({
            closeText: null,
            modal: true,
            buttons: {
                'Вернуться к редактированию': backToEdit,
            },
            close: backToEdit,
        });
        return false;
    }
    return true;
};

var checkNotSelfRelative = function (backToEdit) {
    if (!window.relativesForm) return true;

    if (window.relativesForm.selfRelative()) {
        var dialog = $('<p>Нельзя быть родственником самому себе.</p>').dialog({
            closeText: null,
            modal: true,
            buttons: {
                'Вернуться к редактированию': backToEdit,
            },
            close: backToEdit,
        });
        return false;
    }
    return true;
};

var checkDuplicateRelative = function (backToEdit) {
    if (!window.relativesForm) return true;

    var ids = window.relativesForm.duplicateRelative();

    if (ids.length > 0) {
        var msg = '<p>Родственник(и) с id ' + ids.join() + ' встречается более одного раза.</p>';
        var dialog = $(msg).dialog({
            closeText: null,
            modal: true,
            buttons: {
                'Вернуться к редактированию': backToEdit,
            },
            close: backToEdit,
        });
        return false;
    }
    return true;
};

var checkRelativeTypeCompatibility = function (backToEdit) {
    if (!window.relativesForm) return true;

    if (window.relativesForm.correctRelationType()) {
        var dialog = $('<p>Степень родства не соответствует полу выбранной персоны.</p>').dialog({
            closeText: null,
            modal: true,
            buttons: {
                'Вернуться к редактированию': backToEdit,
            },
            close: backToEdit,
        });
        return false;
    }
    return true;
};

var checkRelativeCommentConnector = function (backToEdit) {
    if (!window.relativesForm) return true;

    if (window.relativesForm.emptyCommentConnector()) {
        commentConnectorErrorDialog(backToEdit);
        return false;
    }
    return true;
};

var checkMaterialTypeNotEmpty = function (backToEdit) {
    if (!window.materialsForm) return true;

    if (window.materialsForm.materialTypeIsEmpty()) {
        var dialog = $(
            '<p>Поле "Тип материала" у присоединяемого материала должно быть заполнено</p>'
        ).dialog({
            closeText: null,
            modal: true,
            buttons: {
                'Вернуться к редактированию': backToEdit,
            },
            close: backToEdit,
        });
        return false;
    }
    return true;
};

var checkMaterialNotEmpty = function (backToEdit) {
    if (!window.materialsForm) return true;

    if (window.materialsForm.materialIsEmpty()) {
        var dialog = $(
            '<p>Поле "Материал" или "Материал строкой" у присоединяемого материала должно быть заполнено</p>'
        ).dialog({
            closeText: null,
            modal: true,
            buttons: {
                'Вернуться к редактированию': backToEdit,
            },
            close: backToEdit,
        });
        return false;
    }
    return true;
};

var checkMaterialId = function (backToEdit) {
    if (!window.materialsForm) return true;

    if (window.materialsForm.correctMaterialId()) {
        var dialog = $(
            '<p>Проверьте правильность создания записи. Указан ID несуществующего материала</p>'
        ).dialog({
            closeText: null,
            modal: true,
            buttons: {
                'Вернуться к редактированию': backToEdit,
            },
            close: backToEdit,
        });
        return false;
    }
    return true;
};

var submitAction = null;

var process_exit_action = function (e, action) {
    submitAction = action;
    if (window.rankForm) window.rankForm.onSave();

    if (window.servingNameForm) window.servingNameForm.onSave();

    if (window.namesForm) window.namesForm.onSave();

    if (window.displayNameForm) window.displayNameForm.onSave();

    if (window.birthPlaceForm) window.birthPlaceForm.onSave();

    if (window.deathPlaceForm) window.deathPlaceForm.onSave();

    if (window.relativesForm) window.relativesForm.onSave();

    if (window.materialsForm) window.materialsForm.onSave();

    e.preventDefault();

    if (!window.submitLock) window.submitLock = new SubmitLock();

    window.submitLock.lock();

    var submitForm = function () {
        $('#action').attr('name', action); //(1)
        $('form.u-person-form').submit();
    };

    var backToEdit = function () {
        window.submitLock.unlock();
        $(this).dialog('close');
    };

    var WarningChain = function () {
        var self = this;

        self._idx = 0;
        self._chain = [];

        self.push = function (e) {
            self._chain.push(e);
        };

        self.checkAndSubmit = function () {
            self._idx = 0;
            if (0 == self._chain.length) submitForm();
            else self.checkNext();
        };

        self.checkNext = function () {
            if (self._idx >= self._chain.length) {
                submitForm();
                return;
            }

            var checker = self._chain[self._idx];
            self._idx++;

            if (
                checker(backToEdit, function () {
                    $(this).dialog('close');
                    self.checkNext();
                })
            )
                self.checkNext();
        };
    };

    var warningChain = new WarningChain();

    if ($('#id_sex').length) warningChain.push(checkSex);
    if (window.rankForm && !window.rankForm.isPrimary) {
        if ($('#id_bryansk_eparchy').length && $('#id_moscow_eparchy').length && $('#id_is_martyr').length) {
            warningChain.push(checkSection);
        }
    }


    if (window.rankForm) {
        warningChain.push(checkPersonRank);

        if (window.servingNameForm) {
            warningChain.push(checkMonkNameRankCompatible);
        }
    }

    if (window.namesForm && window.rankForm && window.servingNameForm && window.displayNameForm) {
        warningChain.push(checkDisplayNameChangedState);
    }

    if (window.relativesForm) {
        //        warningChain.push(checkRelativeNotEmpty);
        warningChain.push(checkRelativePersonId);
        warningChain.push(checkNotSelfRelative);
        warningChain.push(checkDuplicateRelative);
        warningChain.push(checkRelativeTypeCompatibility);
        warningChain.push(checkRelativeCommentConnector);
    }

    if (window.materialsForm) {
        warningChain.push(checkMaterialNotEmpty);
        warningChain.push(checkMaterialTypeNotEmpty);
        warningChain.push(checkMaterialId);
    }

    if ($('.u-serving-form').length) warningChain.push(checkServingCommentConnector);

    if ($('.u-persecuted-form').length) warningChain.push(checkPersecutedCommentConnector);

    if ($('.u-persecuted-new-form').length) warningChain.push(checkPersecutedNewCommentConnector);

    if ($('.u-award-form').length) warningChain.push(checkAwardCommentConnector);

    if ($('.u-ordination-form').length) warningChain.push(checkOrdinationCommentConnector);

    if ($('.u-info-form').length) warningChain.push(checkInfoCommentConnectors);

    if ($('#id_birthday_date').length) warningChain.push(checkBirthDate);

    if ($('#id_death_date').length) warningChain.push(checkDeathDate);

    if ($('.u-serving-form-church-rank').length) warningChain.push(checkServingRank);

    if ($('.u-serving-form-eparchy').length) warningChain.push(checkServingEparchy);

    if ($('.u-material-person-pages').length) warningChain.push(checkMaterialPages);

    if ($('#id_serving_places-TOTAL_FORMS').length) warningChain.push(checkServingCountry);

    warningChain.push(checkFirst);

    warningChain.checkAndSubmit();
};

export function show_record(record_id, e) {
    $.ajax({
        url: '/cabinet/ajax/records/' + record_id + '/?nowrap=1',
        type: 'GET',
        success: function (data, textStatus, jqXHR) {
            $('#draggable-body').html(data);
            if (e) {
                $('#draggable').css({ left: e.pageX, top: e.pageY });
            } else {
                $('#draggable').css({ left: 460, top: 10 });
            }
            $('#draggable').show();

            $("a[class='u-edit-formset']").each(function () {
                if (this.href.indexOf('record_id') != -1) {
                    this.href = this.href.replace(/record_id=[^&]+/, 'record_id=' + record_id);
                } else {
                    this.href = this.href + '?record_id=' + record_id;
                }
            });
        },
        error: function (jqXHR, textStatus, errorThrown) {
            alert('Произошла ошибка загрузки детальной записи!');
        },
    });
}

export function showPersonHistory(url) {
    if (
        document.getElementById('historyCEView') &&
        document.getElementById('historyCEView').checked
    ) {
        url = url + 'short/common/';
    } else if (
        document.getElementById('historyLEView') &&
        document.getElementById('historyLEView').checked
    ) {
        url = url + 'short/literary/';
    } else if (
        document.getElementById('historySEView') &&
        document.getElementById('historySEView').checked
    ) {
        url = url + 'short/scientific/';
    }
    window.open(url);
}

export function Person() {
    if (!$('.u-person-page').length) {
        return;
    }

    $(function () {
        $('#persecutions-form .persecution-link').on('click', function (e) {
            e.preventDefault();
            const documentScrollTop = $(document).scrollTop();
            sessionStorage.setItem(EDIT_SCROLL_POSITION, documentScrollTop);
            window.location.href = $(e.target).closest('a').attr('href');
        })

        $('.u-save-person + a').on('click', function (e) {
            e.preventDefault();
            sessionStorage.setItem(SCROLL_TO_EDIT, 'true');
            window.location.href = $(e.target).closest('a').attr('href');
        });

        $('.u-persecuted-formset').on('change', '.u-persecuted-type select', function (e) {
            var type = $(this).val();

            $.each(
                $(this)
                    .parent()
                    .parent()
                    .parent()
                    .parent()
                    .find('.u-persecuted-subform'),
                function (index) {
                    if (!$(this).is('.u-persecuted-' + type)) {
                        $(this).hide();
                    } else {
                        $(this).show();
                    }
                }
            );
        });

        $('#id_is_published').click(function () {
            if (this.checked) {
                $('#u_published_comment').hide();
            } else {
                $('#u_published_comment').show();
            }
        });

        $('#id_sex').change(function () {
            if (window.namesForm) {
                window.namesForm.sex(this.value);
            }
            if (window.servingNameForm) {
                window.servingNameForm.sex(this.value);
            }
        });

        $('.u-person-form').submit(function () {
            $('.u-persecuted-subform:hidden').remove();
        });

        $('.u-is-sainted input').change(function (e) {
            if ($(this).is(':checked')) {
                $('#id_is_martyr').prop('checked', true);
                $('.u-canonized-group').show();
                $('.u-canonized-section').show();
            } else {
                $('.u-canonized-group').hide();
                $('.u-canonized-section').hide();
                $('#id_is_martyr').prop('checked', false);
            }
        });

        $('.u-relative-to_person').blur();
        $('.u-relative-to_person_text').blur();

        $('.u-unattach-record').click(function (e) {
            var person_id = $(this).data('person-id');
            var record_id = $(this).data('record-id');

            if (!confirm('Вы уверены, что хотите открепить эту запись от персоны?')) {
                return false;
            }

            var $button = $(this);

            $.ajax({
                url: '/cabinet/ajax/records/' + record_id + '/unattach/',
                type: 'POST',
                data: {
                    person_id: person_id,
                },
                success: function (data, textStatus, jqXHR) {
                    $button.parents('tr').remove();
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    alert('Произошла ошибка открепления записи от персоны!');
                },
            });

            e.preventDefault();
        });

        $('.u-process-record').click(function (e) {
            var $this = $(this);

            var $tr = $this.parents('tr');

            var person_id = $this.data('person-id');
            var record_id = $this.data('record-id');

            $.ajax({
                url: '/cabinet/ajax/records/' + record_id + '/process/',
                type: 'POST',
                success: function(data, textStatus, jqXHR) {
                    if (data['status'] == true) {
                        $this.html('<i>Необр.</i>');
                        $tr.removeClass('not_processed');
                    } else {
                        $this.html('<i>Обр.</i>');
                        $tr.addClass('not_processed');
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    alert('Произошла ошибка обработки!');
                },
            });

            e.preventDefault();
        });

        $('.u-publish-record').click(function (e) {
            var $this = $(this);

            var $tr = $this.parents('tr');

            var person_id = $this.data('person-id');
            var record_id = $this.data('record-id');

            $.ajax({
                url: '/cabinet/ajax/records/' + record_id + '/publish/',
                type: 'POST',
                success: function (data, textStatus, jqXHR) {
                    if (data['status'] == true) {
                        $this.html('<i>Неопубл.</i>');
                        $tr.addClass('published');
                    } else {
                        $this.html('<i>Опубл.</i>');
                        $tr.removeClass('published');
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    alert('Произошла ошибка опубликования!');
                },
            });

            e.preventDefault();
        });

        $('input,select').keypress(function (event) {
            return event.keyCode != 13;
        });

        $('.u-show-record').click(function (e) {
            var record_id = $(this).data('record-id');

            show_record(record_id, e);

            e.preventDefault();
        });

        $('#draggable-close').click(function (e) {
            $('#draggable-body').html('');
            $('#draggable').hide();

            $("a[class='u-edit-formset']").each(function () {
                this.href = this.href.replace(/\?record_id=[^&]+/, '');
            });

            e.preventDefault();
        });

        var set_name_display = function (e) {
            if (!$('#id_is_use_name_display').is(':checked')) {
                return true;
            }

            var name_display = [];

            if (
                $('#id_person_type1').length ||
                $('#id_person_type2').length ||
                $('#id_person_type3').length
            ) {
                var $elements = $('.u-type-name-title:visible').find(':selected');

                var is_monk = null;
                var is_coenobite = null;
                var is_schema = null;

                var prefix = '';
                var name_begin = '';
                var name_ending = '';

                $.each($elements, function (index) {
                    if ($(this).val() == 'monk_name') {
                        is_monk = $(this);
                    } else if ($(this).val() == 'coenobite_name') {
                        is_coenobite = $(this);
                    } else if ($(this).val() == 'schema_name') {
                        is_schema = $(this);
                    }
                });

                var name_prefix = '';

                if (is_schema) {
                    name_prefix = is_schema
                        .parent()
                        .parent()
                        .next()
                        .find('input.tt-input')
                        .val();
                    if (
                        is_schema
                            .parent()
                            .parent()
                            .prev()
                            .find('input:checked').length
                    ) {
                        prefix = ' (?)';
                    }
                } else if (is_monk) {
                    name_prefix = is_monk
                        .parent()
                        .parent()
                        .next()
                        .find('input.tt-input')
                        .val();
                    if (
                        is_monk
                            .parent()
                            .parent()
                            .prev()
                            .find('input:checked').length
                    ) {
                        prefix = ' (?)';
                    }
                } else if (is_coenobite) {
                    name_prefix = is_coenobite
                        .parent()
                        .parent()
                        .next()
                        .find('input.tt-input')
                        .val();
                    if (
                        is_coenobite
                            .parent()
                            .parent()
                            .prev()
                            .find('input:checked').length
                    ) {
                        prefix = ' (?)';
                    }
                }

                name_prefix += prefix;
                prefix = '';

                var fio = [];
                if ($('#id_surname1').val()) {
                    if ($('#id_surname1_prefix:checked').length) {
                        prefix = ' (?)';
                    }

                    fio.push($('#id_surname1').val() + prefix);
                    prefix = '';
                }
                if ($('#id_surname2').val()) {
                    if ($('#id_surname2_prefix:checked').length) {
                        prefix = ' (?)';
                    }
                    name_begin = '(';
                    if ($('#id_surname3').val()) {
                        name_ending = ', ';
                    } else {
                        name_ending = ')';
                    }
                    fio.push(name_begin + $('#id_surname2').val() + prefix + name_ending);
                    prefix = '';
                }
                if ($('#id_surname3').val()) {
                    if ($('#id_surname3_prefix:checked').length) {
                        prefix = ' (?)';
                    }
                    name_ending = ')';
                    if ($('#id_surname2').val()) {
                        name_begin = '';
                    } else {
                        name_begin = '(';
                    }
                    fio.push(name_begin + $('#id_surname3').val() + prefix + name_ending);
                    prefix = '';
                }
                if ($('#id_name').val()) {
                    if ($('#id_name_prefix:checked').length) {
                        prefix = ' (?)';
                    }

                    fio.push($('#id_name').val() + prefix);
                    prefix = '';
                }
                if ($('#id_name2').val()) {
                    if ($('#id_name2_prefix:checked').length) {
                        prefix = ' (?)';
                    }

                    fio.push('(' + $('#id_name2').val() + prefix + ')');
                    prefix = '';
                }
                if ($('#id_second_name').val()) {
                    if ($('#id_second_name_prefix:checked').length) {
                        prefix = ' (?)';
                    }

                    fio.push($('#id_second_name').val() + prefix);
                    prefix = '';
                }
                if ($('#id_second_name2').val()) {
                    if ($('#id_second_name2_prefix:checked').length) {
                        prefix = ' (?)';
                    }

                    fio.push('(' + $('#id_second_name2').val() + prefix + ')');
                    prefix = '';
                }

                if (fio.length > 0) {
                    if (name_prefix) {
                        name_prefix += ' ' + '(' + fio.join(' ') + ')<br>';
                    } else {
                        name_prefix += fio.join(' ') + '<br>';
                    }
                    name_display.push(name_prefix);
                }

                if ($('#id_rank').val()) {
                    if ($('#id_rank_prefix:checked').length) {
                        prefix = ' (?)';
                    }

                    name_display.push(
                        $('#id_rank')
                            .find('option:selected')
                            .text()
                            .trim() + prefix
                    );
                    prefix = '';
                }

                if ($('#id_is_sainted').val() && $('#id_canonization_rank_typeahead').val()) {
                    name_display.push($('#id_canonization_rank_typeahead').val());
                }
            }

            $('#id_name_display').val(name_display.join(', '));
        };

        $('#delete-person-photo a').click(function () {
            $('#delete-person-photo input').val('1');
            $('#person-photo').html('<a class="thumbnail" id="person-photo-thumbnail"></a>');
            $('#upload-photo-button').hide();
            $(this).hide();
        });

        jQuery('.u-add-more').on('click', function (event) {
            if ($(this).hasClass('u-add-more__no-scroll')) {
                return;
            }
            var parentBlock = $(this).closest('.u-append-form-here-parent');
            var elem = parentBlock.find('.u-append-form-here').prev('.row');
            var timer = null;
            if ($(elem).length) {
                timer = setTimeout(function () {
                    jQuery('html, body')
                        .stop()
                        .animate(
                            {
                                scrollTop: $(elem).offset().top,
                            },
                            200
                        );
                }, 200);
            }
        });

        $('.u-person-form').on('change', '.scroll-more-js', function () {
            var scrollMoreJs = $('.scroll-more-js');
            var item1 = $(this);
            var item2 = $(scrollMoreJs[scrollMoreJs.length - 1]);

            if (item1[0] === item2[0]) {
                jQuery('html, body')
                    .stop()
                    .animate(
                        {
                            scrollTop: $(item1[0]).offset().top - 25,
                        },
                        200
                    );
            }
        });
    });

    $(function () {
        $('#draggable').draggable();

        if ($('.u-save-person').length) {
            exitLock();

            $('.u-save-person').click(process_exit);
            $('.u-save-person-close').click(process_exit_redirect);
            $('.u-save-person-new').click(process_exit_new);
        }

        $('.u-datepicker-day input').mask('00', { placeholder: '__' });
        $('.u-datepicker-month input').mask('00', { placeholder: '__' });
        $('.u-datepicker-year input').mask('0000', { placeholder: '____' });
    });

    // Меняет z-index подписей окон под фотографиями
    $(function () {
        $('.u-photos-formset').on('mousedown', '.form-control_resizable', function (e) {
            $('.form-control_resizable').removeClass('form-control_resizable_active');
            $(e.target).addClass('form-control_resizable_active');
        });

        /**
         * Прячет лишние сообщения о пробной странице
         */
        // $('.sandbox-subtitle').hide();
        // $('.sandbox-subtitle').eq(0).show();
        //
        // $('.sandbox-title').hide();
        // $('.sandbox-title').eq(0).show();
        //
        // $('.sandbox-info-tooltip').hide();
        // $('.sandbox-info-tooltip').eq(0).show();

        /**
         * Импорт данных для песочницы
         */
        var tooltipContent =
            '<p>На этой странице можно заполнять любые поля и по нажатию <br> кнопки «Посмотреть на сайте» увидеть, каким будет результат на сайте. ' +
            'При этом никому, кроме Вас, данная страница на сайте не видна, поэтому можно работать спокойно. ' +
            'По нажатию кнопки «Очистить» все поля страницы очищаются, а по нажатию кнопки «Импортировать» во ' +
            'все поля можно перенести данные любой существующей на сайте персоны.' +
            ' Очень эффективным способом освоения рабочего кабинета является выбрать для образца какую-нибудь' +
            ' реальную (желательно, тщательно проработанную и отредактированную) страницу персоны на сайте и ' +
            'попытаться заполнить все поля пробной страницы так, чтобы создать полную копию страницы персоны, взятой за образец. ' +
            '</p><span class="tooltip-close-btn glyphicon glyphicon-remove"></span>';

        $('.sandbox-info-tooltip').tooltip({
            content: function () {
                return $(this).prop('title');
            },
            disabled: true,
            classes: {
                'ui-tooltip': 'highlight',
            },
            close: function (event, ui) {
                $(this).tooltip('disable');
            },
            position: {
                of: '.sandbox-info-tooltip',
                at: 'center top',
                my: 'center bottom-5',
            },
        });

        $('.sandbox-info-tooltip').on('click', function () {
            if ($('.sandbox-info-tooltip').is(':ui-tooltip')) {
                $(this)
                    .tooltip('enable')
                    .tooltip('open');
            }
        });

        $('.sandbox-info-tooltip').on({
            click: function () {
                $(this).tooltip({ items: '.sandbox-info-tooltip', content: tooltipContent });
                $(this).tooltip('open');
            },
            mouseout: function (e) {
                e.stopImmediatePropagation();
                // $(this).tooltip({ items: ".sandbox-info-tooltip", content: tooltipContent});
                // $(this).tooltip("open");
            },
        });

        $('body').on('click', '.tooltip-close-btn', function () {
            if ($('.sandbox-info-tooltip').is(':ui-tooltip')) {
                $('.sandbox-info-tooltip')
                    .tooltip('disable')
                    .tooltip('close');
            }
        });

        $('.sandbox__btn_import').on('click', showImportModalWIndow);

        $('.sandbox__btn_clear').on('click', showClearModalWIndow);

        function showClearModalWIndow(event) {
            event.preventDefault();
            $(
                '<div><p><b>Внимание</b>, все существующие данные на пробной странице будут удалены</p>'
            ).dialog({
                closeText: null,
                modal: true,
                minWidth: 590,
                buttons: [
                    {
                        text: 'Очистить',
                        click: function () {
                            window.location.pathname = '/cabinet/sandbox/person/clean/';
                        },
                    },
                    {
                        text: 'Закрыть',
                        click: function () {
                            $(this).dialog('close');
                        },
                    },
                ],
            });
        }

        function showImportModalWIndow(event) {
            event.preventDefault();
            $(
                '<div><p><b>Внимание</b>, все существующие данные на пробной странице будут перезаписаны</p>' +
                "<br><input  style='width: 200px' placeholder='ID персоны' " +
                "type='text'><br><p class='sandbox-modal__warning' style='color: red; display: none'>Неверный ID</p></div>"
            ).dialog({
                closeText: null,
                modal: true,
                minWidth: 590,
                // open: function( event, ui ) {
                //     $(this).find('input').val(typeheadInputValue);
                // },
                buttons: [
                    {
                        text: 'Импортировать',
                        click: function () {
                            var inputValue = $(this)
                                .find('input')
                                .val();

                            $(this)
                                .find('input')
                                .on('focus', function () {
                                    $('.sandbox-modal__warning').hide();
                                });

                            $.get('/cabinet/ajax/person/' + inputValue + '/', function (data) {
                                window.location.pathname =
                                    '/cabinet/sandbox/person/import/' + inputValue + '/';
                            }).fail(function () {
                                $('.sandbox-modal__warning').show();
                            });

                            $(typeheadInput).val(inputValue);
                        },
                    },
                    {
                        text: 'Закрыть',
                        click: function () {
                            $(this).dialog('close');
                        },
                    },
                ],
            });
        }
    });
}
